<template>
  <div id="layout-default">
    <navbar class="sticky top-0 w-full" />
    <smart-banner-mobile v-if="isSmartBannerShown && appStore.isMobileScreen" />
    <main id="layout-default-main" class="relative flex flex-col">
      <slot class="page-content" />
    </main>
    <addendum v-if="isAddendumShown" />
    <smart-banner-desktop v-if="isSmartBannerShown && !appStore.isMobileScreen" />

    <lazy-login-modal v-if="isAddendumShown" />
  </div>
</template>

<script setup lang="ts">
import Addendum from '@/components/common/addendum.vue'
import Navbar from '@/components/navbar/navbar.vue'
import LazyLoginModal from '@/components/login/lazy-login-modal.vue'
import SmartBannerMobile from '@/components/common/smart-banner-mobile.vue'
import { AsyncDataKeys } from '@/constants/async-data-keys'
import { useRegionStore } from '@/store/region'
import { useAppStore } from '@/store/app'

const SmartBannerDesktop = defineAsyncComponent(() =>
  dynamicImport(() => import('@/components/common/smart-banner-desktop.vue'), 'smart-banner-desktop')
)

const { locale } = useI18n()

const hasSmartBannerClosedCookie = useHasSmartBannerClosedCookie()

const appStore = useAppStore()
const regionStore = useRegionStore()

const { regionId } = useRegion()

const route = useRoute()

const debouncedFetchRegionList = useDebounceFn(regionStore.fetchRegionList, 300)

const isAccountDeletionPage = computed(() => checkIfAccountDeletionPage(route.name))
const isAddendumShown = computed(() => !isAccountDeletionPage.value)
const isSmartBannerShown = computed(() => {
  return !isAccountDeletionPage.value && !hasSmartBannerClosedCookie.value
})

await useAsyncData(
  useAsyncDataKey(AsyncDataKeys.REGION, [regionId.value]),
  async () => {
    if (typeof regionId.value !== 'number') return {}

    const region = await regionStore.fetchRegion(regionId.value)
    return region
  },
  { watch: [regionId, locale], dedupe: 'cancel' }
)

watch(locale, debouncedFetchRegionList)
</script>

<style lang="scss" scoped>
#layout-default-main {
  min-height: var(--content-min-height);
}
</style>
